var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, action, makeObservable } from 'mobx';
import { child, primitive } from '../../../../utils/serializr/serializr';
import { Entity } from '../../../entity/Entity';
import { MedFileInfo } from './modules/MedFileInfo';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { withDefault } from '../../../../utils/serializr/schema/middle/withDefault';
import { runtime } from '../../../runtime/Runtime';
import { MedFileSource } from './modules/MedFileSource';
import { alias } from '../../../../utils/serializr/schema/middle/alias';
import { editable } from '../../../../utils/mobx/decorators/editable';
import { MediaLabel } from '../../../learnware/LearnwareEnums';
export class MedFile extends Entity {
    mediumLabel = MediaLabel.None;
    /** path to the medium, e.g. '/data2/img/1/S18k9UUXb.png' */
    filePath = '';
    /** base64 information of the file (only temporarily used - automatic upload to file system) */
    base64 = '';
    /** if the file is modified, this value is incremented  */
    fileVersion = 1;
    /** File size in Bytes */
    fileSize = 0;
    /** TextAlternative for Medium */
    alternativeText = '';
    isScheduledForUpload = false;
    medFileSource;
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get medFileInfo() {
        return new MedFileInfo(this);
    }
    get medFileEdit() {
        return new runtime.solidPackages.Edit.classes.MedFileEdit(this);
    }
    /** Returns a reliable source (file or base64) */
    get src() {
        return this.base64.length > 0 ? this.base64 : `${this.filePath}?version=${this.fileVersion}`;
    }
    get trait() {
        return this.parent;
    }
    get aspect() {
        return this.parent.aspect;
    }
    get actor() {
        return this.parent && this.parent.actor ? this.parent.actor : undefined;
    }
    /** Use this one! Reliable value of file extension */
    get fileExtension() {
        if (this.context.app.appInfo.isAppInEditBuild && this.filePath && (this.fileSize === 0 || this.fileSize === 52)) {
            setTimeout(this.medFileInfo.detectFileSize, 10);
        }
        const extension = this.medFileInfo.base64Extension || this.medFileInfo.derivedExtensionFromFilename;
        if (extension === 'jpeg')
            return 'jpg';
        return extension;
    }
    set fileExtension(e) { }
    /** true if currently no valid source is defined for this medium */
    get isEmpty() {
        return this.filePath.length === 0 && this.base64.length === 0;
    }
    scheduleForUpload() {
        // to be used in computeds
        runtime.runtimeScheduler.addToNextStateChange(() => {
            this.uploadNow();
        });
    }
    uploadNow() {
        // to be used in actions, uploads medium before entity save
        if (this.isScheduledForUpload)
            return;
        this.isScheduledForUpload = true;
        //   runtime.runtimeScheduler.addToNextIdleStateChange(() => {
        if (!this.context.app.appInfo.isAppInEditBuild)
            return;
        if (this.base64.length === 0)
            return;
        this.context.app.solidEdit.editUploadFile.foundValuesWithBase64.push(this);
    }
    static get serializeInfo() {
        return {
            extends: Entity.serializeInfo,
            props: {
                mediumLabel: true,
                filePath: true,
                base64: withDefault(primitive, ''),
                fileSize: true,
                fileExtension: true,
                version: withDefault(primitive, ''),
                medFileSource: alias('fileSource', withDefault(child(MedFileSource), {})),
            },
        };
    }
}
__decorate([
    editable()
], MedFile.prototype, "mediumLabel", void 0);
__decorate([
    editable()
], MedFile.prototype, "filePath", void 0);
__decorate([
    editable()
], MedFile.prototype, "base64", void 0);
__decorate([
    editable()
], MedFile.prototype, "fileVersion", void 0);
__decorate([
    editable()
], MedFile.prototype, "fileSize", void 0);
__decorate([
    editable()
], MedFile.prototype, "alternativeText", void 0);
__decorate([
    memoize
], MedFile.prototype, "medFileInfo", null);
__decorate([
    memoize
], MedFile.prototype, "medFileEdit", null);
__decorate([
    computed
], MedFile.prototype, "src", null);
__decorate([
    action.bound
], MedFile.prototype, "scheduleForUpload", null);
__decorate([
    action.bound
], MedFile.prototype, "uploadNow", null);
__decorate([
    memoize
], MedFile, "serializeInfo", null);
export var LicenseReviewed;
(function (LicenseReviewed) {
    LicenseReviewed["No"] = "no";
    LicenseReviewed["Yes"] = "yes";
    LicenseReviewed["AtUpload"] = "onUpload";
})(LicenseReviewed || (LicenseReviewed = {}));
